// Regras compartilhadas dos dropdowns de campo relacionado (SelectEdit no formulário, SelectSearch no filtro do grid) e da
// store moduleSubjectAttribute. Ficam num lugar só para que tamanho de página, TTL e montagem de chave/consulta não possam
// divergir entre os três (antes o 50 estava repetido em três arquivos e o grid e o formulário guardavam a MESMA lista sob
// chaves diferentes, buscando-a duas vezes).

// Tamanho da página pedida à API (fetch) e usado para calcular o total de páginas.
export const RELATED_PAGE_SIZE = 50

// Validade de uma lista guardada na store. As listas (clientes, softwares...) mudam raramente, mas não deve ser preciso
// recarregar a página para ver um cadastro novo: depois deste prazo a próxima abertura do dropdown busca de novo.
export const RELATED_OPTIONS_TTL_MS = 5 * 60 * 1000

export const relatedPath = (attrId) => `SubjectAttribute/related/${attrId}`

export const pageCount = (totalResults) => Math.ceil((totalResults || 0) / RELATED_PAGE_SIZE)

// Uma entrada válida da store tem a lista de itens. Uma entrada de erro ({ error }) ou a ausência de entrada não são "carregadas":
// o dropdown deve tentar de novo em vez de quebrar lendo itens de undefined.
export const isLoadedOptions = (options) => Array.isArray(options?.itens)

// Campo de lista fixa (AttributeValue discreto): o contexto da TalkModal já traz os valores COM rótulo e na ordem do dropdown
// (subjectAttributes[].attributeValues[].label), então a lista pode sair dali, sem pedir GET /SubjectAttribute/related/{id}.
// Só serve quando a lista é completa e cabe numa página (<= RELATED_PAGE_SIZE valores) e o contexto tem rótulo (contexto antigo, sem
// "label", cai na requisição de sempre). Devolve o mesmo formato que a store guarda para a resposta da API.
export const seedFromAttributeValues = (subjectAttribute) => {
  const values = subjectAttribute?.attributeValues

  if (!subjectAttribute?.isDiscreteValue || !Array.isArray(values)) return null
  if (values.length === 0 || values.length > RELATED_PAGE_SIZE) return null
  if (values.some((v) => v.label === undefined)) return null

  return {
    itens: values.map((v) => ({ id: v.attributeValueId, name: v.label })),
    currentPage: 1,
    totalResults: values.length
  }
}

// Uma lista guardada está COMPLETA quando traz todos os resultados (cabe numa página): só então dá para buscar localmente.
export const isCompleteOptions = (options) => isLoadedOptions(options) && options.itens.length >= (options.totalResults ?? 0)

// Mesma regra de busca do back-end para lista fixa (GetAttributeValuesQueryHandler): o termo é quebrado por espaço e TODOS os pedaços
// têm que estar contidos no rótulo, sem diferenciar maiúscula. Rótulo nulo só casa pedaço vazio. Mantém a ordem da lista.
export const filterOptionsLocally = (itens, term) => {
  const pieces = (term ?? '').split(' ').map((piece) => piece.toLowerCase())

  return itens.filter((item) => {
    const label = (item.name ?? '').toLowerCase()
    return pieces.every((piece) => label.includes(piece))
  })
}

// Parâmetros que dependem de outro campo (ex.: ?cliente=12). Aceita um objeto { identifier, value } ou uma lista deles.
// Um valor ausente (pai ainda vazio) não vira "?cliente=null": o parâmetro é simplesmente omitido.
export const buildExtraParams = (params) => {
  const list = Array.isArray(params) ? params : params ? [params] : []

  const query = list
    .filter((p) => p && p.identifier && p.value !== null && p.value !== undefined && p.value !== '' && p.value !== 'null')
    .map((p) => `${p.identifier}=${encodeURIComponent(p.value)}`)

  return query.length ? `?${query.join('&')}` : ''
}
